import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import CursorTrail from "./CursorTrail";
import Footer from "./components/Footer";

function WorkCard({
  imageSrc,
  title,
  category,
  description,
  isUnblurred,
  isHovered,
  link,
  index,
}) {
  const [cardHovered, setCardHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const currentRef = cardRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, index * 50);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [index]);

  return (
    <Link to={link} className="work-card-link">
      <div
        ref={cardRef}
        className={`work-card ${isUnblurred ? "unblurred" : ""} ${
          isVisible ? "visible" : ""
        }`}
        onMouseEnter={() => setCardHovered(true)}
        onMouseLeave={() => setCardHovered(false)}
      >
        <div
          className={`work-image-wrapper ${
            cardHovered || isUnblurred || isHovered ? "unblurred" : ""
          }`}
        >
          <img src={imageSrc} alt={title} className="work-image" />
        </div>
        <div className="work-info">
    <div className="work-title-category">
      <h3 className="work-title">{title}</h3>
      <p className="work-category">{category}</p>
    </div>
    <p className="work-description">{description}</p>
  </div>
      </div>
    </Link>
  );
}

function Home() {
  const [isCursorTrailActive, setIsCursorTrailActive] = useState(false);
  const toggleCursorTrail = () => {
    setIsCursorTrailActive((prevState) => !prevState);
  };
  return (
    <CursorTrail isActive={isCursorTrailActive}>
      <div className="home-container">
        <div
          className="cursor-trail-square"
          onMouseEnter={toggleCursorTrail} /* onMouseEnter */
          style={{
            width: "80px",
            height: "80px",
            backgroundColor: " rgba(150, 0, 0, 1)",
            margin: "20px",
          }}
        ></div>
        <header className="app-header">
          <div className="header-content">
            <div className="central-content">
              <h1 className="site-title">Shun Ueno</h1>
              <div className="nav-links">
                <Link to="/about" className="nav-link about-link">
                  ABOUT
                </Link>
                <a
                  href="mailto:shunueno@stanford.edu"
                  className="nav-link work-link"
                >
                  CONTACT
                </a>
              </div>

              <div className="about-section visible">
                <p className="about-text">
                  Product designer and developer pursuing a double major in Design and Computer Science at Stanford. 
                  With a background in management consulting and full-stack engineering, I focus on creating solutions that are strategically thoughtful and optimized for performance.
                </p>
              </div>
            </div>
          </div>
        </header>
        <hr className="divider" />
        <section id="works" className="works-section">
          <div className="works-container">
            {[
              {
                imageSrc: "/a2a_cover.png",
                title: "The Actor to Actor Game",
                link: "/works/actortoactor",
                category: "Product Design",
                description:
                  "Interactive web app that challenges players to connect actors through movies and co-stars, inspired by the 'Six Degrees of Kevin Bacon' theory",
              },
              {
                imageSrc: "/calexplore_main.png",
                title: "CalExplore",
                link: "/works/calexplore",
                category: "Product Design",
                description:
                  "A project for Caltrain to enhance their mobile app with a swipe-based Explore Feature connecting riders to local attractions and businesses",
              },
              {
                imageSrc: "/poster_mockup3.png",
                title: "ECLIPSE",
                link: "/works/eclipse",
                category: "Graphic Design",
                description:
                  "Poster series celebrating overlooked innovators and intellectuals, redefining what it means to be an icon through storytelling and graphic design",
              },
              {
                imageSrc: "/pwr.png",
                title: "Hostile Architecture and Inaccessibility",
                link: "/works/hostile-architecture",
                category: "Design Research",
                description:
                  "Critical design analysis of how anti-homeless architecture in Tokyo impacts accessibility for people with disabilities, highlighting its ethical and social implications",
              },
              {
                imageSrc: "/radar2.png",
                title: "VALUENEX",
                link: "/works/valuenex",
                category: "Consulting",
                description:
                  "Full-stack software engineering and data analysis initiatives optimizing client processes and informing strategic decisions",
              },
              
              

              /*
              {
                imageSrc: "/rockpath2.png",
                title: "Miscellaneous Side Projects",
                link: "/works/justforfun",
              },
              {
                imageSrc: "/frag2.png",
                title: "FRGNCE",
              },*/
            ].map((card, index) => (
              <WorkCard
                key={card.title}
                imageSrc={card.imageSrc}
                title={card.title}
                category={card.category}
                description={card.description}
                isUnblurred={true}
                isHovered={false}
                link={card.link}
                index={index}
              />
            ))}
          </div>
        </section>
        <hr className="divider" />
        <Footer />
      </div>
    </CursorTrail>
  );
}

export default Home;
